import { Component, OnInit, OnDestroy, Input,AfterViewInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { StudentChecklistService } from '../../_services/index';
import { DOCUMENT} from '@angular/common';
import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ngx-page-scroll';

@Component({
  selector: 'app-student-checklist',
  templateUrl: './student-checklist.component.html',
  styleUrls: ['./student-checklist.component.css'],
  providers:[StudentChecklistService]
  
})
export class StudentChecklistComponent implements OnInit {
  currentListId;
   checklistForm: FormGroup;
   resData;
   listData;
   resDataList;
   public checkboxesArray2 = [];
   listName;
   checkboxesArray=[];
   loading = false;
   error: boolean;
   errorFlag: boolean;
   successMessage: string;
   errorMessage: string;
   submitBtnText = '';
   currentUser;
  constructor(private _fb: FormBuilder,
    private router: Router,
    public api: StudentChecklistService,   
    private route: ActivatedRoute,
    private pageScrollService: PageScrollService, 
    @Inject(DOCUMENT) private document: any) { }

  ngOnInit() 
  {
    
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.route.params.subscribe(par=>
    {
      this.currentListId=par.lid;
    })
    this.getCheckListByid();
    //this.getQuestions();
    this.createForm();

    /* this.checkboxesArray['0']['a'] = 'wdwd1';
    this.checkboxesArray['0']['b'] = 'wdwd1';

    this.checkboxesArray['1']['a'] = 'wdwd2';
    this.checkboxesArray['1']['b'] = 'wdwd2'; */

  //   this.checkboxesArray = [{

  //     cat:{
  //         name:'tobias',
  //         legs:4
  //     },
  //     dog:{
  //         name:'bobi',
  //         legs:4
  //     }
  // }];    
  }
  createForm()  {    
    let formControlArray2 = new FormArray(this.checkboxesArray2);   
    this.checklistForm  = this._fb.group(
       {
         checklist2: formControlArray2,
        
       });     
      //  console.log(this.checklistForm.controls.checklist2);     
   }
 
  getCheckListByid(){
    this.loading = true;
    this.api.getCheckListByid(this.currentListId, this.currentUser.userId).subscribe(res=>{
      this.resData=res;
      if(this.resData.status==1)
      {
      this.listName=this.resData.data.listname;
      
      
      let i = 0;
      for (let checklist of this.resData.data.groups){
        /* this.checkboxesArray = [];
        
        this.checkboxesArray.push({
          isChosen: false,
          name: checklist.tasks.name,
          id: checklist.tasks.id,
        }); */

        this.checkboxesArray2.push(this._fb.group({
         //isChosen: false,
          gname: checklist.tasklable,
          color:checklist.gcolor,
          gid:checklist.id,
          tasks:this._fb.array([ ]),
          subgroup:this._fb.array([ ]),
        }));

        this.addType(i,checklist.gtasks);
        this.addSubGroup(i,checklist.subgroups);

       i++;
     }
    }
    this.loading = false;
    })
  }

  /* createType1() {
    return this._fb.group({
      isChosen: false,
      name:'',
      id:''
    });
  } */

  createType(task) {
    
    return this._fb.group({
      isChosen: task.isChosen,
      name:task.name,
      tid:task.tid,
      lid:task.lid
    });
  }

  createsubType(task) {
    
    return this._fb.group({
      isChosen: task.isChosen,
      name:task.name,
      tid:task.tid,
      lid:task.lid
    });
  }

  createSubgroup(i,j,subgroups) {
    return this._fb.group({
      isChosen: subgroups.open,
      tasklable:subgroups.tasklable,
      subtasks:this._fb.array([this.addSubGroupTask(i,j,subgroups.tasks)]),
    });
  }

  addType(i: number,tasks) {     
    const control = this.checklistForm.controls.checklist2['controls'][i].controls.tasks;    
    for (let task of tasks){
      control.push( this.createType(task) );
    }
  }

  addSubGroup(i: number,subgroup) {
    let j = 0;
    const control = this.checklistForm.controls.checklist2['controls'][i].controls.subgroup;
    for (let group of subgroup) {
      control.push(this.createSubgroup(i,j,group));
      j++;
    }
  }

  addSubGroupTask(i: number,j: number,subgrouptask) { 
    const control = this.checklistForm.controls.checklist2['controls'][i].controls.subgroup['controls'][j].controls.subtasks;    
    for (let sgtask of subgrouptask){
      control.push( this.createsubType(sgtask) );
    }
  }

  onSubmit() {  
    console.log(this.checklistForm.controls.checklist2);   
    this.loading = true;
    let arr=[];
    for(let i=0;i<this.checklistForm.controls['checklist2']['controls'].length;i++)
    {
      arr.push(this.checklistForm.controls['checklist2']['controls'][i].value)
    }
    let formData=JSON.stringify(arr);
    this.api.postStudentChecklist$(formData)
    .subscribe(res=>{
      let resData=JSON.parse(res._body);
      if(resData.success==1){
        this.errorFlag = false;
        this.successMessage = resData.message;
        this.loading = false;        
        let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.student-layout-wrapper');
        this.pageScrollService.start(pageScrollInstance);
      }
    },
    error => {
      this.errorFlag = true;
        console.log(error);
      this.errorMessage = 'Something went wrong.';

        this.errorFlag = true;
        this.loading = false;
        let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.student-layout-wrapper');
        this.pageScrollService.start(pageScrollInstance);
    
      
    },
    )
  }
 
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-checklist/student-checklist.component.ts